<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama","AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TabloVerileri: [],
      TabloDetayVerileri: [],
      ProsesDegerler:[],
   
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi:[],
      donem:"",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },

  },

  methods: {



    Get() {
      this.bugun = new Date();
      //alert(this.bugun);

      this.ProsesDegerler = [];


     
                let Filter = "&StrUstDonemId="+this.DonemId+"&StrDonemId=" + this.AltDonemId;

                if(this.BirimId!=null && this.BirimId!=""){
                    Filter= Filter+"&BirimId="+this.BirimId;
                }
                console.log(Filter)
                           
                this.ActionsFilterGet({ Service: "StrRaporlama/GetProsesVeriGirisDurum", Page: this.Page, Filter: Filter }).then((res) => {
                  this.ProsesDegerler = res.Data;

                  console.log(this.ProsesDegerler)
                        
                });



    },

        ExcelExport(table, name){  
           
                if (!table.nodeType) table = this.$refs.verigirisraporu;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
        
  
      }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Ödenek Talep Raporu',
                  'Ödenek Talep Raporu',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>


  
    <div ref="verigirisraporu" class="table-responsive">
      

    <div class="table-responsive">
      <table style="width:100%">
        <tr>
          <td colspan="4" style="text-align: center;">
              <div> <h4>{{donem.Aciklama}} Veri Giriş Durumları (Birim Bazlı) </h4></div>
          </td>
        </tr>

    
    </table>
    <br>


    <table style="border: 1px solid; border-collapse: collapse; " border="1" class="table  table-md table-bordered border-success mb-0"  >

      <thead class="table-light" style="text-align: center;">

       <tr style="text-align: center; font-weight: bold;">
        <th style="width:60%">Birim Adı</th>
        <th style="width:20%">Hedef</th>
        <th style="width:20%">Gerçekleşme</th>
       </tr>
      </thead>
      <tbody>
      <tr v-for="(Data,index) in ProsesDegerler" :key="index">
      <td>{{Data.Birim}}</td>
      <td style="text-align: center;">{{ Data.Hedef }}</td>
      <td style="text-align: center;">{{ Data.Gerceklesme }}</td>
   
      </tr>


     
    </tbody>
    </table>
    
    </div>
    
    </div>
  </div>
</template>
